import {
  Box,
  Button,
  Dialog,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useCallback, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { useLocation, useNavigate } from 'react-router';

import ClearIcon from 'common/shared-ui/src/icons/ClearIcon';

import ChevronIcon from '../../../../../packages/common/shared-ui/src/icons/ChevronIcon';

// Original class: modalRoot
const StyledModalRoot = styled(Dialog)(theme => ({
  '& .MuiPaper-root.MuiDialog-paper': {
    overflow: 'visible',
    padding: '30px 20px',
    maxWidth: '600px',
    backgroundColor: '#F1F2F8',
    borderRadius: '16px',
    maxHeight: 'calc(100% - 130px)',
    margin: 0,
    '& .MuiFormControl-root.MuiTextField-root.formTextField': {
      width: '200px',
      '& .MuiInputBase-root.MuiOutlinedInput-root .MuiInputBase-input.MuiOutlinedInput-input':
        {
          backgroundColor: '#fff',
          borderRadius: '16px',
        },
    },
  },
}));

const GanttIssueRelatedModal = ({
  intl,
  open,
  data,
  handleSave,
  handleClose,
}) => {
  const [modalData, setModalData] = useState([
    { id: 33233, delay: null },
    { id: 153543, delay: null },
  ]);

  const handleClearButton = useCallback(() => {
    handleClose();
  }, [handleClose]);

  const navigate = useNavigate();
  const handleError = useCallback(
    error => {
      if (error) {
        navigate(`/errors/error-${error.status}`);
      }
    },
    [navigate],
  );

  const handleSaveButton = useCallback(() => {
    handleSave();
  }, [handleSave]);

  const handleTextField = useCallback(
    (event, index) => {
      const updatedObject = { ...modalData[index], delay: event.target.value };
      setModalData([
        ...modalData.slice(0, index),
        updatedObject,
        ...modalData.slice(index + 1),
      ]);
    },
    [modalData],
  );

  const handleNumberField = useCallback(
    (event, field) => {
      const reg = new RegExp(/^[0-9-]*$/);
      if (reg.test(event.target.value)) {
        handleTextField(event, field);
      }
    },
    [handleTextField],
  );

  return (
    <StyledModalRoot open={open} disableRestoreFocus fullWidth>
      <Grid container direction={'column'}>
        {modalData?.map((item, index) => {
          return (
            <Grid
              key={index}
              sx={{
                marginTop: index > 0 ? '16px' : 0,
              }}
            >
              <Grid
                key={index}
                container
                sx={{
                  alignItems: 'center',
                }}
              >
                <Typography
                  variant='h5'
                  sx={{
                    color: '#41424E',
                    flex: 1,
                  }}
                >
                  <Grid
                    container
                    sx={{
                      alignItems: 'center',
                    }}
                  >
                    <Box
                      sx={{
                        marginRight: '16px',
                      }}
                    >
                      {intl.formatMessage({ id: 'issue_page_follows' })}
                    </Box>
                    <Box
                      sx={{
                        marginRight: '24px',
                      }}
                    >{`#${item.id}`}</Box>
                    <Box
                      sx={{
                        marginRight: '24px',
                      }}
                    >{`${intl.formatMessage({
                      id: 'issue_page_related_task_delay',
                    })} (${intl.formatMessage({ id: 'issue_page_related_task_days' })})`}</Box>
                  </Grid>
                </Typography>
                <TextField
                  key={index}
                  sx={{ marginLeft: '15px' }}
                  onChange={event => handleNumberField(event, index)}
                  placeholder={intl.formatMessage({ id: 'enter' })}
                  fullWidth
                  variant='outlined'
                  required
                  value={item.delay ? item.delay : ''}
                  className={'formTextField'}
                  slotProps={{
                    inputLabel: { shrink: false },
                  }}
                />
              </Grid>
            </Grid>
          );
        })}
      </Grid>
      <Grid
        container
        sx={{
          justifyContent: 'center',
          marginTop: '30px',
        }}
      >
        <Button
          disableRipple
          variant='cutGreyPrimaryBig'
          onClick={handleClearButton}
        >
          <Typography
            variant='h5'
            sx={{
              fontWeight: 700,
            }}
          >
            <FormattedMessage id='cancel' defaultMessage='cancel' />
          </Typography>
        </Button>
        <Box
          sx={{
            marginLeft: 1,
          }}
        >
          <Button
            disableRipple
            variant='cutBlueSecondary'
            onClick={handleSaveButton}
          >
            <Typography
              variant='h5'
              sx={{
                fontWeight: 700,
              }}
            >
              <FormattedMessage id='save' defaultMessage='Clear' />
            </Typography>
          </Button>
        </Box>
      </Grid>
    </StyledModalRoot>
  );
};

export default injectIntl(GanttIssueRelatedModal);
